module.exports = __webpack_public_path__ + "static/img/head.bf920434.png";